



























    import { Component, Vue } from "vue-property-decorator";
    // require styles
	import "swiper/dist/css/swiper.css";
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    
    const YOUPAI = 'https://appd.knowbox.cn/ss/activity/knowbox-web/img/';

	@Component({
        components: {
            swiper,
            swiperSlide 
        }
    })
	export default class Join extends Vue {
        public $refs!: {
			swiper: any;
        };

        private swiperOption: any = {
            slidesPerView: 'auto',
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true 
            },
            allowClick: false,
            preventClicks: true,
            preventClicksPropagation: true
        }

        private imgList: any = [
            [
                `${YOUPAI}join/screen-1-col-11.png`,
                `${YOUPAI}join/screen-1-col-12.png`
            ],
            [
                `${YOUPAI}join/screen-1-col-21.png`,
                `${YOUPAI}join/screen-1-col-22.png`
            ],
            [
                `${YOUPAI}join/screen-1-col-31.png`,
                `${YOUPAI}join/screen-1-col-32.png`,
                `${YOUPAI}join/screen-1-col-33.png`
            ],
            [
                `${YOUPAI}join/screen-1-col-41.png`,
            ],
            [
                `${YOUPAI}join/screen-1-col-51.png`,
                `${YOUPAI}join/screen-1-col-52.png`
            ],
            // [
            //     `${YOUPAI}join/screen-1-col-61.png`,
            //     `${YOUPAI}join/screen-1-col-62.png`
            // ]
        ];

        private get swiper() {
			return this.$refs.swiper.swiper;
        }
    }
